import * as regexp from './regexp';

// TrimSuffix returns s without the provided trailing suffix string.
// If s doesn't end with suffix, s is returned unchanged.
export function TrimSuffix(s: string, suffix: string): string {
    if (s.endsWith(suffix)) {
        return s.substring(0, s.length - suffix.length);
    }
    return s;
}

export function TrimPrefix(s: string, prefix: string): string {
    if (s.startsWith(prefix)) {
        return s.substring(prefix.length);
    }
    return s;
}

export function Capitalize(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function Trim(s: string, cutset: string): string {
    return s.replace(new RegExp(`^[${regexp.Escape(cutset)}]+|[${regexp.Escape(cutset)}]+$`), '');
}

export function TrimLeft(s: string, cutset: string): string {
    return s.replace(new RegExp(`^[${regexp.Escape(cutset)}]+`), '');
}

export function TrimRight(s: string, cutset: string): string {
    return s.replace(new RegExp(`[${regexp.Escape(cutset)}]+$`), '');
}

export function CamelToTitle(camelCase: string) {
    return camelCase.
        replace(/([A-Z])/g, match => ` ${match}`).
        replace(/^./, match => match.toUpperCase()).
        trim();
}
